<template>
  <div>
    <div class="head">
      <Input v-model="where.name" placeholder="搜索学员姓名" class="txtput" @on-change="getStudents(2)"></Input>
      <div class="iconfont icon-pailie sai-xuan" @click="saiXuan = !saiXuan"></div>
    </div>
    <div class="sai-xuan-lan" v-show="saiXuan">
      <div class="select">
        <Select v-model="where.product_id" style="width:200px;margin:20px 0 0 20px;">
          <Option value="0">
            全部课程
          </Option>
          <Option v-for="item in lessonList" :value="item.id" :key="item.id">{{
            item.store_name
          }}</Option>
        </Select>
        <!-- <Select
          v-model="where.status"
          style="width:200px;margin:20px 0 0 20px;"
        >
          <Option
            v-for="item in classtime"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select> -->
      </div>
      <div class="button">
        <button @click="saixuanok">确认</button>
        <button @click="saixuanno">取消</button>
      </div>
    </div>
    <!-- <Scroll :on-reach-bottom="handleReachBottom"  distance-to-edge=10 :height="height"> -->
    <div class="wrapper" ref="wrapper">
      <div class="content">
        <div class="studentCard" v-show="!saiXuan" v-for="item in studentlist" :key="item.Id">
          <div class="top">
            <div class="left" @click="getStudentUserCodeV(item)" v-if="item.avatar">
              <!-- <img v-if="!item.avatar" src="@assets/images/1.jpg" alt="avatar" /> -->
              <img :src="item.avatar" alt="" />
            </div>
            <div class="left" @click="getStudentUserCodeV(item)" v-if="!item.avatar">
              <img v-if="!item.avatar" src="@assets/images/1.jpg" alt="avatar" />
            </div>
            <div class="right">
              <div class="name" style="font-weight: bolder ">{{ item.name }}
                <img @click="getStudentUserCodeV(item)" style="width: 20px;float: right;margin-right: 35px;"
                  src="@assets/images/ewm.png" />
              </div>
              <div class="lesson-info" v-for="lesson in item.product" :key="lesson.product_id">
                <div class="store-name">{{ lesson.store_name }}</div>
                <div class="classtime">剩余:{{ lesson.classtime }}</div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <button>
              <a :href="'tel:' + item.phone" @click.stop="">联系电话</a>
            </button>
            <button @click.stop="classtimeChangeV(item)">课时变更</button>
          </div>
        </div>
      </div>
    </div>

    <!-- </Scroll> -->
    <div class="classtimechange" v-if="cTchange">
      <div class="name">学员:&#160&#160{{ current.name }}</div>
      <!-- <Select v-model="product_id" style="width:300px;margin: 10px 20px;">
        <Option v-for="item in lessonList" :value="item.id" :key="item.id">{{
          item.store_name
        }}</Option>
      </Select> -->
      <field v-model="valueName" is-link readonly error required placeholder="请选择课程"
        style="width: 300px;margin: 20px; border-style: solid;border-color: rgb(220 222 226);border-radius: 10px;"
        @click="showPicker = true" class="lesson-input" />
      <Input v-model="classtime" size="large" placeholder="请输入课时"
        style="width: 300px;margin: 10px 20px;border-style: solid;border-color: rgb(220 222 226);border-radius: 10px;"
        type="tel" />
      <RadioGroup v-model="status" size="large" style="margin: 10px 20px;">
        <Radio label="1">
          <Icon type=""></Icon>
          <span>增加</span>
        </Radio>
        <Radio label="0">
          <Icon type=""></Icon>
          <span>减少</span>
        </Radio>
      </RadioGroup>
      <div class="changeButton">
        <button @click="cancel">取消</button>
        <button @click="submit">确认</button>
      </div>
    </div>
    <div v-if="currentCode.hasOwnProperty('code')" class="bindhome classtimechange">
      <div style="text-align: center;margin-top:10px;font-size: 18px;font-weight: 700">
        扫码绑定学员:{{ currentCode.name }}
      </div>
      <img :src="currentCode.code" alt="" width="100%;" />
    </div>
    <div :class="cTchange || currentCode.hasOwnProperty('code') ? 'mark' : ''" @click="currentCode = {}"></div>
    <popup v-model="showPicker" round position="bottom">
      <picker :columns="nameList" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" />
    </popup>
  </div>
</template>

<script>
import { getLesson } from "@api/store";
import { getStudent, updateClasstime, getStudentUserCode } from "@api/user";
import { Picker, Field, Popup } from "vant";

import BScroll from 'better-scroll'

export default {
  name: "StudentManage",
  components: {
    Picker,
    Field,
    Popup
  },
  data: function () {
    return {
      nameList: [],
      currIndex: 0,
      valueName: '',
      showPicker: false,
      lessonList: "111",
      saiXuan: false,
      classtime: [
        { label: "全部", value: 0 },
        { label: "快到期", value: 1 },
        { label: "已到期", value: 2 }
      ],
      where: {
        product_id: 0,
        status: 0,
        page: 1,
        limit: 10,
        name: ""
      },
      product_id: 0,
      studentlist: [],
      cTchange: false, //课时变更卡片开关
      status: "1", //课时增加或减少 0减少 1增加
      classtime: "", //课时数
      current: "",
      currentCode: {}, //当前学员绑定家长的二维码信息
      height: 0,
      defaultImg: require('@assets/images/1.jpg')
    };
  },
  methods: {
    onConfirm(value, index) {
      this.valueName = value;
      this.showPicker = false;
      this.currIndex = index;
    },
    getLessons() {
      var _this = this;
      getLesson().then(res => {
        _this.lessonList = res.data.lesson;
        this.nameList = res.data.lesson.map(item => item.store_name)
      });
    },
    getStudents(state) {
      var _this = this;
      getStudent(this.where).then(res => {
        if (state) {
          if (state === 2) {
            _this.studentlist = res.data.student;
            this.scroll.refresh();
            this.scroll.scrollTo(0, 0, 0);
            this.scroll.finishPullUp();
          } else {
            if (res.data.student.length !== _this.studentlist.length) {
              _this.studentlist = res.data.student;
              this.scroll.finishPullUp();
            } else {
              this.$Message.success('已经到底啦');
            }
          }
        } else {
          _this.studentlist = res.data.student;
        }
      }).catch(() => {
        this.$Message.success('数据加载失败');
      });
    },
    saixuanok() {
      this.saiXuan = !this.saiXuan;
      this.getStudents();
    },
    saixuanno() {
      this.where = {
        product_id: 0,
        status: 0,
        page: 1,
        limit: 10,
        name: ""
      };
      this.saiXuan = !this.saiXuan;
    },
    classtimeChangeV(current) {
      this.current = current;
      this.cTchange = true;
    },
    cancel() {
      this.cTchange = true;
      this.classtime = '';
      this.valueName = '';
      this.$router.go(0);
    },
    submit() {
      var _this = this,
        data = {
          product_id: this.lessonList[this.currIndex].id,
          times: this.classtime,
          student_id: this.current.Id,
          status: this.status
        };
      if (!this.classtime) {
        this.$Message.success('请填写课时');
        // console.log(this.lessonList[this.currIndex])

      } else if (!this.lessonList[this.currIndex].id) {

        this.$Message.success('请选择课程');
      } else {
        updateClasstime(data).then(res => {
          if (res.status == 200) {
            _this.$Message.success(res.msg);
            this.getStudents();
            this.getLessons();
            this.cTchange = false;
            this.classtime = "";
          }
        }).catch(res => {
          if (res.status == 400) {
            _this.$Message.err(res.msg);
          }
        });
      }

    },
    async getStudentUserCodeV($sid) {
      var res = await getStudentUserCode($sid.Id);

      if (res.status == 200) {
        this.currentCode = {
          code: res.data.code_src,
          name: $sid.name
        };
      } else {
        this.$Message.err("系统错误");
      }
    },
    handleReachBottom(state) {
      this.where.limit += 10;
      this.getStudents(state);
    }
  },
  mounted: function () {
    // this.height = window.innerHeight || document.documentElement.clientHeight;
    this.getLessons();
    this.getStudents();
    this.scroll = new BScroll(this.$refs.wrapper, {
      pullUpLoad: true,
      click: true,
      snapThreshold: 0.5,
      bounceTime: 1000
    });
    this.scroll.on('pullingUp', () => {
      this.scroll.refresh();
      this.handleReachBottom(1);
    })
  },
  watch: {
    $route(to, from) {
      if ((from.path !== to.path && to.path !== '/student_manage/index' && from.path === '/student_manage/index')) {
        this.cTchange = false;
      }
    }
  }
};
</script>

<style scoped>
.head {
  display: flex;
  background: #2980f7;
  align-items: center;
  height: 1rem;
}

.txtput>>>.ivu-input {
  margin: 10px 10px;
  width: 90%;
}

.sai-xuan {
  color: #fff;
  font-size: 22px;
  margin-right: 10px;
}

.sai-xuan-lan {
  background: #fff;
  margin-left: 30%;
  border-bottom: 1px solid #fff;
  /* height: 93vh; */
}

.button {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  margin: 100px 0;
}

.button button {
  background: #2980f7;
  color: #fff;
  width: 80px;
  height: 30px;
  border-radius: 5px;

}

.studentCard {
  background: #fff;
  margin: 10px 5px 0px 5px;
  border-top: 1px solid #fff;
  border-radius: 20px;
  box-shadow: 0.1rem 0.1rem 0.1rem rgb(255, 255, 255);
}

.left img {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-left: 10px;
  margin-bottom: -40px;
}

.top {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left {
  flex: 2;
}

.right {
  flex: 8;
  margin-left: 10px;
}

.lesson-info {
  display: flex;
  margin-bottom: 10px;
}

.name {
  margin: 10px 0;
  font-size: 17px;
  font-weight: bolder;
}

.store-name {
  flex: 7;
}

.classtime {
  flex: 3;
  color: red;
}

.bottom {
  /* border-top: 1px dashed #eee; */
  display: flex;
  justify-content: space-around;
}

.bottom button {
  background-color: #2980f7;
  color: #fff;
  margin-left: 68px;
  width: 100px;
  height: 30px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.bottom button a {
  color: #fff;
}

.classtimechange {
  position: fixed;
  background: #fff;
  z-index: 999;
  left: 50%;
  transform: translate(-50%, 50%);
  bottom: 50%;
  border-radius: 10px;
}

.mark {
  background: rgba(63, 60, 60, 0.65);
  width: 100vw;
  height: 100vh;
  z-index: 99;
  position: fixed;
  top: 0;
}

.classtimechange .name {
  text-align: center;
}

.changeButton button {
  background: #2980f7;
  width: 100px;
  height: 40px;
  color: #cecece;
  line-height: 40px;
  border-radius: 5px;
  font-size: 18px;
}

.mark[data-v-206f98e2] {
  background: #ededed;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  position: fixed;
  top: 0;
}

.changeButton {
  display: flex;
  justify-content: space-around;
  margin: 10px 10px;
}

.bindhome {
  width: 70vw;
  margin: 0 auto;
}

.wrapper {
  height: calc(100vh - 1rem);
  overflow: hidden;
}

.content {
  padding-bottom: 2rem;
}

.lesson-input {
  /* padding: 0.2rem 0.5rem;
  border-style: solid; */
}
</style>